import React from 'react'

import { PageHeader } from 'maxboapp-components'

const IndexPage = () => {
	return <PageHeader title='ERP app' />
}

export default IndexPage
